import React, { useState } from "react";
import { Button } from "sulu-admin-bundle/components";
import styles from "./dynamic-search.module.scss";
import { ResourceRequester } from "sulu-admin-bundle/services";

import { parametarExtractor } from "../../utils/parametarExtractor";

function fromCamelCaseToNormal(text) {
    if (!/[a-z][A-Z]/.test(text)) {
        return text;
    }

    return text.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
}

const DynamicSearch = ({ data, onSearch, paginationOptions, translate }) => {
    const options = parametarExtractor(data);
    const fields = Object.entries(options)
        .filter(([key]) => key.startsWith("field"))
        .map(([_, field]) => field);

    const initialFormData = fields.reduce((acc, field) => {
        acc[field] = "";
        return acc;
    }, {});

    const [state, setState] = useState({
        error: "",
        invalidFields: [],
        formData: initialFormData,
    });
    const { error, invalidFields, formData } = state;

    const handleChange = (e, field) => {
        setState((prev) => ({
            ...prev,
            formData: {
                ...prev.formData,
                [field]: e.target.value,
            },
        }));

        if (e.target.value.trim() !== "") {
            setState((prev) => ({
                ...prev,
                invalidFields: prev.invalidFields.filter(
                    (invalidField) => invalidField !== field
                ),
            }));
        }
    };

    const handleSearchClick = async () => {
        const emptyFields = fields.filter(
            (field) => formData[field].trim() === ""
        );

        if (emptyFields.length > 0) {
            setState((prev) => ({
                ...prev,
                invalidFields: emptyFields,

                error: translate("sulu_admin.passports.error"),
            }));

            return;
        }

        const params = {
            filter: {
                ...Object.fromEntries(
                    fields.map((field) => [field, formData[field]])
                ),
            },
        };

        setState((prev) => ({
            ...prev,
            invalidFields: [],
            error: "",
        }));

        onSearch(paginationOptions, params);
    };

    const getInputClassName = (field) => {
        const baseClass = styles["dynamic-search__search"];
        const errorClass = invalidFields.includes(field)
            ? styles["dynamic-search__error"]
            : "";
        return `${baseClass} ${errorClass}`.trim();
    };

    return (
        <>
            {fields.map((field, index) => {
                const fieldTranslation =
                    "sulu_admin.users." + field.toLowerCase();
                return (
                    <div
                        className={
                            styles[
                                `${
                                    field === "birthday"
                                        ? "dynamic-search__container--small"
                                        : "dynamic-search__container"
                                }`
                            ]
                        }
                        key={index}
                    >
                        <input
                            style={{
                                color:
                                    field === "birthday" &&
                                    formData[field] === ""
                                        ? "#494949"
                                        : "",
                            }}
                            name={field}
                            className={getInputClassName(field)}
                            type={field === "birthday" ? "date" : "text"}
                            placeholder={translate(fieldTranslation)}
                            value={formData[field]}
                            onChange={(e) => handleChange(e, field)}
                            max={
                                field === "birthday"
                                    ? new Date().toISOString().split("T")[0]
                                    : undefined
                            }
                        />
                    </div>
                );
            })}

            <button
                className={styles["dynamic-search__button"]}
                onClick={handleSearchClick}
            >
                {translate("sulu_admin.passports.search")}
            </button>

            {error && <div className={styles["error-message"]}>{error}</div>}
        </>
    );
};

export default DynamicSearch;
